import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { RootContextProvider } from './contexts';
import reportWebVitals from './reportWebVitals';
import './fontello/css/fontello.css'
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <RootContextProvider>
        <App />
    </RootContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
